import React, { useEffect, useState } from 'react';
import { Box, Skeleton, Typography } from '@mui/material';
import { BarChart } from '../../../shared';
import { YOE_OPTIONS, YOE_SERIES } from './constants';
import { useDispatch, useSelector } from 'react-redux';
import { getYearsOfExperience } from '../../../../redux/thunks/physicanTargetListAnalysisThunk';

const YearsOfExperience = (props) => {
    const dispatch = useDispatch();
    const { company } = useSelector(state => state.company);
    const { yearofExp } = useSelector(state => state.physicianTargetListAnalysis);
    const { chartSeries, isLoading } = yearofExp;

    useEffect(() => {
        if(company.id){
            dispatch(getYearsOfExperience({ companyId: company.id }));
        }
        
    },[company.id]);
    
    return (
        <Box className="custom-tool-tip custom-hover-bar-color apexchart-horizontal-bar-chart yoe-container">
            <Box className="pb-20px">
                <Typography className="text-lg-semi-bold gray-900">
                    A. Years of Experience
                </Typography>
            </Box>
            {isLoading ? <Skeleton height={'100%'} variant='rectangular' width={'100%'}/> :
                <BarChart chartOptions={YOE_OPTIONS} chartSeries={chartSeries} />
            }
           
        </Box>
    );
};

export default YearsOfExperience;
